import { Component, OnInit, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { CatalogItem, CatalogService } from '../catalog.service';
import { CatalogSection, CatalogSectionService } from '../../catalog-section.service';
import { RestComponent } from '../../lib/RestComponent';
import { CartService } from '../../cart/cart.service';
import { CompareService } from '../../compare/compare.service';
import { ConsultService } from '../../consult.service';
import { BreadCrumbsService } from '../../breadcrumbs.service';
import { CityService } from '../../city.service';

@Component({
  selector: 'catalog-detail',
  templateUrl: './catalog-detail.component.html',
  styleUrls: ['./catalog-detail.component.less']
})
export class CatalogDetailComponent extends RestComponent implements OnInit {
  data: CatalogItem;
  h1Text: string = '';
  otherProducts: CatalogItem[] = [];
  quantity: number = 1;
  offerIndex: number = 0;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
    private cartService: CartService,
    private compareService: CompareService,
    private consult: ConsultService,
    private breadCrumbsService: BreadCrumbsService,
    private catalogService: CatalogService,
    private catalogSectionService: CatalogSectionService,
    private cityService: CityService,
  ) {
    super();
  }

  public ngOnInit() {
    this.route.data.subscribe(async (data: {data: {item: CatalogItem}}) => {

      if (data.data.item.OFFERS) {
        data.data.item.OFFERS = data.data.item.OFFERS.map((offer) => {
          offer.PROPS = offer.PROPS.filter((prop) => prop.VALUE);
          return offer;
        });
        data.data.item.OFFERS = data.data.item.OFFERS.filter((offer) => offer.PROPS.length > 0);
        if (data.data.item.OFFERS.length === 0) delete data.data.item.OFFERS;
      }
      this.data = data.data.item;

      const regionId = this.route.snapshot.pathFromRoot[0].pathFromRoot[0].firstChild.params['id'];

      if (regionId) {
        this.cityService.city = await this.cityService.get({
          filter: {CODE: regionId}
        }).then(cities => cities[0]);
      }
	  
	  if(this.cityService.city.PROPERTY_INFLECTED_VALUE == 'России') {
		  console.log(this.cityService.city.PROPERTY_INFLECTED_VALUE);
		  let titleText = `${this.data.NAME} купить`;
		  let descriptionText = `${this.data.NAME}. Продажа юридическим лицам.`;
			  descriptionText += ` Наш телефон: +7 (846) 205-79-59 | Интернет-магазин shop.zolotoykod.ru`;
			  
		  this.h1Text = `${this.data.NAME}`;

		  // special title, h1 and description for services
		  if (this.data.IBLOCK_ROOT_SECTION_ID === '26') {
			titleText = `${this.data.NAME}. Купить, цена, характеристики`;
			this.h1Text = this.data.NAME;
		  }
		  this.titleService.setTitle(titleText);
		  this.metaService.updateTag({name: 'description', content: descriptionText});
	  }
	  
	  else {
		  let titleText = `${this.data.NAME} купить в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
		  let descriptionText = `${this.data.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}. Продажа юридическим лицам.`;
			  descriptionText += ` Наш телефон: +7 (846) 205-79-59 | Интернет-магазин shop.zolotoykod.ru`;
			  
		  this.h1Text = `${this.data.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;

		  // special title, h1 and description for services
		  if (this.data.IBLOCK_ROOT_SECTION_ID === '26') {
			titleText = `${this.data.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}. Купить, цена, характеристики`;
			this.h1Text = this.data.NAME;
		  }
		  this.titleService.setTitle(titleText);
		  this.metaService.updateTag({name: 'description', content: descriptionText});
	  }

      

      try {
        if (this.data.PROPERTY_RECOMEND_PRODUCTS_VALUE) {
          this.otherProducts = await this.catalogService.get({
            filter: {ID: this.data.PROPERTY_RECOMEND_PRODUCTS_VALUE.VALUE, ACTIVE: 'Y'},
            navParams: {nPageSize: 20}
          });
        }
      } catch (err) {}

      let sectionCode;
      try {
        const section: CatalogSection = await this.catalogSectionService.getByCode(this.data.IBLOCK_SECTION_ID);
        sectionCode = section.CODE;
      } catch (err) {
        sectionCode = this.data.IBLOCK_SECTION.ID;
      }

      this.breadCrumbsService.create([
        {
          name: this.data.IBLOCK_SECTION.NAME,
          href: '/catalog/section/' + sectionCode,
          color: 'general-primary'
        },
        {
          name: this.data.NAME,
          color: 'general-primary'
        }
      ]);
    });
  }
  public async addToCart() {
    if (!this.data.OFFERS && !this.data.CAN_BUY) return false;
    if (this.data.OFFERS && !this.data.OFFERS[this.offerIndex].PRICE.PRICE.CAN_BUY) return false;
    this.loadingState = true;

    let idProduct = this.data.ID;
    if (this.data.OFFERS) idProduct = this.data.OFFERS[this.offerIndex].ID;

    try {
      const res = await this.cartService.add({ID: idProduct, QUANTITY: this.quantity});
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.error = false;
      this.loadingState = false;
    } catch (e) {
      this.error = true;
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    }
  }

  public async addToCompare() {
    this.loadingState = true;
    try {
      const res = await this.compareService.add(this.data.ID);
      this.data.IS_IN_COMPARE = true;
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.error = false;
      this.loadingState = false;
    } catch (e) {
      this.error = true;
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    }
  }

  public async removeFromCompare() {
    this.loadingState = true;
    try {
      const res = await this.compareService.delete(this.data.ID);
      this.data.IS_IN_COMPARE = false;
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.error = false;
      this.loadingState = false;
    } catch (e) {
      this.error = true;
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    }
  }
}

@Injectable()
export class CatalogDetailResolver implements Resolve<{ item: CatalogItem }> {
  constructor(
    private catalogService: CatalogService,
    private router: Router
  ) {}

  public async resolve(route: ActivatedRouteSnapshot): Promise<{ item: CatalogItem }> {
    const res: { item: CatalogItem } = { item: null };

    try {
      const item = await this.catalogService.getByCode(route.paramMap.get('code'));
      item.PROPERTIES = [];
      for (const key in item) {
        if (item.hasOwnProperty(key)
            && key.startsWith('PROPERTY_') && key.endsWith('_VALUE')
            && key !== 'PROPERTY_ADPAR_PROPERTIES_VALUE'
            && key !== 'PROPERTY_ADPAR_CODE_VALUE'
            && key !== 'PROPERTY_WARRANTY_VALUE'
            && key !== 'PROPERTY_ADPAR_MARKUP_VALUE'
            && key !== 'PROPERTY_PARTNUMBER_VALUE'
            && key !== 'PROPERTY_ADPAR_FINISHED_VALUE'
            && item[key] && !Array.isArray(item[key]) && item[key].VALUE
            && (typeof item[key].VALUE === 'string' || typeof item[key].VALUE === 'number')) {
          item.PROPERTIES.push(item[key]);
        }
      }
      res.item = item;

      return res;
    } catch (e) {
      this.router.navigate(['/404']);
      return null;
    }
  }
}
